import TableDynamic from "./TableDynamic"

const TableReportIndividual = () => {
  
  return (
    <>
      <TableDynamic />
    </>
  )
}

export default TableReportIndividual
 